<template>
  <CContainer class="pt-5" fluid>
    <Loading :active.sync="isLoading"></Loading>
    <CRow>
      <CCol class="col-12">
        <h3 class="pl-3 mb-0 pb-0">APHT Payment</h3>
        <b-breadcrumb class="my-0 pt-1" style="border-bottom: 0px">
          <b-breadcrumb-item to="/invoice-apht/created">
            <CIcon name="cil-credit-card" />
            Created
          </b-breadcrumb-item>
          <b-breadcrumb-item :to="{ name: 'Invoice APHT Memo List', params: { collateralId: $route.params.collateralId } }">Memo</b-breadcrumb-item>
          <b-breadcrumb-item active>Create</b-breadcrumb-item>
        </b-breadcrumb>
      </CCol>
    </CRow>
    <CForm>
      <CCard class="custom-form-card mb-4">
        <CCardBody class="px-3">
          <CRow>
            <CCol class="col-6">
              <h5 class="custom-header">Data FIMS</h5>
              <CRow>
                <CCol class="col-12">
                  <b-form-group label="No. Sertifikat Tanah:">
                    <b-form-input v-model="formData.contractDetail.nomorSertifikatTanah" disabled></b-form-input>
                  </b-form-group>
                </CCol>
                <CCol class="col-12">
                  <b-form-group label="Nama Sertifikat:">
                    <b-form-input v-model="formData.contractDetail.namaSertifikatTanah" disabled></b-form-input>
                  </b-form-group>
                </CCol>
                <CCol class="col-12">
                  <b-form-group label="Status Sertifikat:">
                    <b-form-input v-model="formData.contractDetail.statusHak" disabled></b-form-input>
                  </b-form-group>
                </CCol>
                <CCol class="col-12">
                  <b-form-group label="Harga Objek:">
                    <b-form-input v-model="formData.contractDetail.nilaiAppraisal" disabled></b-form-input>
                  </b-form-group>
                </CCol>
                <CCol class="col-12">
                  <b-form-group label="Biaya Notaris:">
                    <b-form-input v-model="formData.contractDetail.notaryFee" disabled></b-form-input>
                  </b-form-group>
                </CCol>
              </CRow>
            </CCol>
            <CCol class="col-6">
              <h5 class="custom-header">Data FIFApps</h5>
              <CRow>
                <CCol class="col-12">
                  <b-form-group label="No. Appl:">
                    <b-form-input v-model="formData.contractDetail.applNo" disabled></b-form-input>
                  </b-form-group>
                </CCol>
                <CCol class="col-12">
                  <b-form-group label="No. Kontrak:">
                    <b-form-input v-model="formData.contractDetail.contractNo" disabled></b-form-input>
                  </b-form-group>
                </CCol>
                <CCol class="col-12">
                  <b-form-group label="Nilai Penjaminan:">
                    <b-form-input v-model="formData.contractDetail.nilaiPenjaminan" disabled></b-form-input>
                  </b-form-group>
                </CCol>
                <CCol class="col-12">
                  <b-form-group label="Pokok Pembiayaan:">
                    <b-form-input v-model="formData.contractDetail.pokokPembiayaan" disabled></b-form-input>
                  </b-form-group>
                </CCol>
              </CRow>
            </CCol>
            <CCol class="col-12 mt-3">
              <h5 class="custom-header">Create Invoice</h5>
            </CCol>
            <CCol class="col-6">
              <CCol class="col-12">
                <CRow>
                  <CCol class="col-12">
                    <b-form-group
                      :invalid-feedback="formData.vendorId.feedback"
                      valid-feedback="Vendor ID is available."
                      label="Vendor ID"
                      label-for="form-vendor-id"
                      :state="formData.vendorId.isValid"
                    >
                      <b-input-group>
                        <b-form-input
                          v-model="formData.vendorId.value"
                          :state="formData.vendorId.isValid"
                          placeholder="Vendor ID"
                          id="form-vendor-id"
                          @input="clearFormVendor"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-button
                            variant="primary"
                            :disabled="formData.vendorId.isValid"
                            :title="formData.vendorId.isValid ? 'ID already valid' : ''"
                            @click="validateVendorId"
                            style="width:4.5rem"
                          >
                            <b-spinner small v-if="formData.vendorId.isChecking" />
                            <span v-else>Check</span>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </CCol>
                  <CCol class="col-12">
                    <b-form-group
                      invalid-feedback="This input is required."
                      label="Vendor Name:"
                      label-for="form-vendor-name"
                      :state="formData.vendorName.isValid"
                    >
                      <b-form-input
                        v-model="formData.vendorName.value"
                        :state="formData.vendorName.isValid"
                        placeholder="Vendor Name"
                        disabled
                        id="form-vendor-name"
                      ></b-form-input>
                    </b-form-group>
                  </CCol>
                  <CCol class="col-12">
                    <b-form-group
                      invalid-feedback="This input is required."
                      label="Vendor Bank:"
                      label-for="form-vendor-bank"
                      :state="formData.vendorBank.isValid"
                    >
                      <b-form-input
                        v-model="formData.vendorBank.value"
                        :state="formData.vendorBank.isValid"
                        placeholder="Vendor Bank"
                        disabled
                        id="form-vendor-bank"
                      ></b-form-input>
                    </b-form-group>
                  </CCol>
                  <CCol class="col-12">
                    <b-form-group
                      invalid-feedback="This input is required."
                      label="Vendor Bank Account:"
                      label-for="form-vendor-account"
                      :state="formData.vendorBankAccount.isValid"
                    >
                      <b-form-input
                        v-model="formData.vendorBankAccount.value"
                        :state="formData.vendorBankAccount.isValid"
                        placeholder="Vendor Bank Account"
                        disabled
                        id="form-vendor-account"
                      ></b-form-input>
                    </b-form-group>
                  </CCol>
                  <CCol class="col-12">
                    <b-form-group
                      invalid-feedback="This input is required."
                      label="Vendor Bank Account Name"
                      label-for="form-vendor-accountName"
                      :state="formData.vendorAccountName.isValid"
                    >
                      <b-form-input
                        v-model="formData.vendorAccountName.value"
                        :state="formData.vendorAccountName.isValid"
                        placeholder="Vendor Bank Account Name"
                        disabled
                        id="form-vendor-accountName"
                      ></b-form-input>
                    </b-form-group>
                  </CCol>
                  <CCol class="col-12">
                    <b-form-group
                      invalid-feedback="This input is required."
                      label="Vendor Status:"
                      label-for="form-vendor-status"
                      :state="formData.vendorStatus.isValid"
                    >
                      <b-form-input
                        v-model="formData.vendorStatus.value"
                        :state="formData.vendorStatus.isValid"
                        placeholder="Vendor Status"
                        disabled
                        id="form-vendor-status"
                      ></b-form-input>
                    </b-form-group>
                  </CCol>
                </CRow>
              </CCol>
            </CCol>
            <CCol class="col-6">
              <CRow>
                <CCol class="col-12">
                  <b-form-group
                    invalid-feedback="This input is required."
                    label="Biaya Notaris Invoice:"
                    label-for="form-invoice-fee"
                    :state="formData.notaryFee.isValid"
                  >
                    <b-form-input
                      :value="formData.notaryFee.value"
                      @input="formData.notaryFee.value = $helper.parseNumber($event)"
                      maxlength="15"
                      onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                      :state="formData.notaryFee.isValid"
                      placeholder="Biaya Notaris Invoice"
                      id="form-invoice-fee"
                    ></b-form-input>
                  </b-form-group>
                </CCol>
                <CCol class="col-12">
                  <b-form-group
                    invalid-feedback="This input is required."
                    label="Nomor Sertifikat:"
                    label-for="form-cert-no"
                    :state="formData.certificateNo.isValid"
                  >
                    <b-form-input
                      v-model="formData.certificateNo.value"
                      maxlength="50"
                      :state="formData.certificateNo.isValid"
                      placeholder="Nomor Sertifikat"
                      id="form-cert-no"
                    ></b-form-input>
                  </b-form-group>
                </CCol>
                <CCol class="col-12">
                  <b-form-group
                    invalid-feedback="This input is required."
                    label="Tanggal Sertifikat:"
                    label-for="form-cert-date"
                    :state="formData.certificateDate.isValid"
                  >
                    <b-form-datepicker
                      v-model="formData.certificateDate.value" 
                      :max="formData.certificateDate.maxValue"
                      id="form-cert-date"
                      placeholder="DD/MM/YYYY"
                      :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                      locale="id"
                      :state="formData.certificateDate.isValid"
                    ></b-form-datepicker>
                  </b-form-group>
                </CCol>
                <CCol class="col-12">
                  <b-form-group
                    invalid-feedback="This input is required."
                    label="Notes Invoice:"
                    label-for="form-invoice-notes"
                    :state="formData.notes.isValid"
                  >
                  <b-form-textarea
                    v-model="formData.notes.value"
                    :state="formData.notes.isValid"
                    maxlength="500"
                    placeholder="Notes"
                    id="form-invoice-notes"
                    rows="4"
                    max-rows="5"
                  ></b-form-textarea>
                  </b-form-group>
                </CCol>
                <CCol class="col-12 col-md-6">
                  <b-form-group
                    invalid-feedback="This input is required."
                    label="Sertifikat HT:"
                    label-for="document-upload-htcert"
                    :valid-feedback="formData.uploadHTCertificate.feedback"
                    :state="formData.uploadHTCertificate.isValid"
                  >
                    <b-form-file
                      v-model="formData.uploadHTCertificate.value"
                      :state="formData.uploadHTCertificate.isValid"
                      :disabled="formData.uploadHTCertificate.isSubmitting"
                      accept=".pdf"
                      ref="document-upload-htcert"
                      @input="onUploadHTCert"
                    ></b-form-file>
                  </b-form-group>
                </CCol>
                <CCol class="col-12 col-md-6">
                  <b-form-group
                    invalid-feedback="This input is required."
                    label="Cover Note:"
                    label-for="document-upload-covernote"
                    :valid-feedback="formData.uploadCoverNote.feedback"
                    :state="formData.uploadCoverNote.isValid"
                  >
                    <b-form-file
                      v-model="formData.uploadCoverNote.value"
                      :state="formData.uploadCoverNote.isValid"
                      :disabled="formData.uploadCoverNote.isSubmitting"
                      accept=".pdf"
                      ref="document-upload-covernote"
                      @input="onUploadCoverNote"
                    ></b-form-file>
                  </b-form-group>
                </CCol>
              </CRow>
            </CCol>
            <CCol class="col-12 pt-4 pb-3">
              <CButton color="primary" class="float-right" style="width:7rem" type="submit" :disabled="isSubmitting" @click="createInvoice">
                <b-spinner small v-if="isSubmitting" />
                <span v-else>Submit</span>
              </CButton>
              <b-btn variant="secondary" class="mr-2 float-right" @click="$router.push({ name: 'Invoice APHT Memo List', params: { collateralId: $route.params.collateralId } })">Cancel</b-btn>
            </CCol>
          </CRow>
        </CCardBody>
      </CCard>
    </CForm>
  </CContainer>
</template>


<script>
export default {
  name: 'InvoiceAdd',
  data() {
    return {
      isLoading: true,

      formData: {
        contractDetail: {
          applNo: "-",
          nomorSertifikatTanah: "-",
          namaSertifikatTanah: "-",
          statusHak: "-",
          contractNo: "-",
          nilaiPenjaminan: "-",
          notaryFee: "-",
          nilaiAppraisal: "-",
          pokokPembiayaan: "-",
          pokokPembiayaanRaw: 0
        },
        vendorId: {
          value: '',
          isChecking: false,
          isValid: null,
          isRequired: true,
          feedback: 'Vendor ID is not valid.',
          payloadKey: "vendorId"
        },
        vendorName: {
          value: '',
          isValid: null,
          isRequired: true,
          payloadKey: "vendorName"
        },
        vendorBank: {
          value: '',
          isValid: null,
          isRequired: true,
          payloadKey: "vendorBank"
        },
        vendorBankAccount: {
          value: '',
          isValid: null,
          isRequired: true,
          payloadKey: "vendorBankAccount"
        },
        vendorAccountName: {
          value: '',
          isValid: null,
          isRequired: true,
          payloadKey: "vendorAccountName"
        },
        vendorStatus: {
          value: '',
          isValid: null,
          isRequired: true,
          payloadKey: "vendorStatus"
        },
        vendorAddress: {
          value: '',
          isValid: null,
          isRequired: true,
          payloadKey: "vendorAddress"
        },
        vendorCity: {
          value: '',
          isValid: null,
          isRequired: true,
          payloadKey: "vendorCity"
        },
        notaryFee: {
          value: '',
          isValid: null,
          isRequired: true,
          payloadKey: "notaryFee"
        },
        certificateNo: {
          value: '',
          isValid: null,
          isRequired: true,
          payloadKey: "certificateNo"
        },
        certificateDate: {
          value: '',
          isValid: null,
          isRequired: true,
          payloadKey: "certificateDate"
        },
        notes: {
          value: '',
          isValid: null,
          isRequired: false,
          payloadKey: "notes"
        },
        uploadHTCertificate: {
          value: null,
          feedback: '',
          isValid: null,
          isRequired: true,
          isSubmitting: false,
          payloadKey: "uploadHTCertificate"
        },
        uploadCoverNote: {
          value: null,
          feedback: '',
          isValid: null,
          isRequired: false,
          isSubmitting: false,
          payloadKey: "uploadCoverNote"
        }
      },

      isSubmitting: false,

      tablePageOptions: [
        { value: 10, text: '10'},
        { value: 20, text: '20'},
        { value: 30, text: '30'},
        { value: 40, text: '40'},
        { value: 50, text: '50'}
      ],

      notes: {
        value: '',
        isValid: null,
        isRequired: false,
        payloadKey: "notes"
      },

      filter: {
        mou: {
          value: null,
          isLoaded: false,
          isValid: null,
          isRequired: true,
          options: [],
          currentPage: 1,
          perPage: 10,
          totalRows: 0,
          totalPages: 0,
          lastQuery: '',
          payloadKey: "mouId"
        },
        contractType: {
          value: null,
          isValid: null,
          isRequired: true,
          options: [
            { value: 'F', text: 'Fiducia' },
            { value: 'R', text: 'Roya' },
            { value: 'A', text: 'APHT' },
          ],
          payloadKey: "contractType"
        },
        office: {
          value: null,
          isLoaded: false,
          isValid: null,
          isRequired: true,
          options: [],
          currentPage: 1,
          perPage: 10,
          totalRows: 0,
          totalPages: 0,
          lastQuery: '',
          payloadKey: "officeCode"
        },
        company: {
          value: null,
          isValid: null,
          isRequired: true,
          options: [],
          payloadKey: "coyId"
        },
        bussUnit: {
          value: null,
          isValid: null,
          isRequired: true,
          options: [],
          payloadKey: "bussUnit"
        },
        platform: {
          value: null,
          isValid: null,
          isRequired: true,
          options: [],
          payloadKey: "platformId"
        },
      },

      table: {

        isLoaded: false,

        selectedItem: null,
        selectedItemIndex: -1,
        selectedItems: [],

        fields: [
          {key: "contractNo", label: "No. Kontrak", sortable: true},
          {key: "customerName", label: "Nama Customer", sortable: true},
          {key: "officeName", label: "Office", sortable: true},
          {key: "applicationDate", label: "Tanggal Pengajuan", sortable: true},
          {key: "assignmentDate", label: "Tanggal Assign", sortable: true},
          { key: "action", label: "Aksi", sortable: false }
        ],

        items: [],

        sort: {
          by: null,
          desc: false
        },

        currentPage: 1,
        perPage: 10,
        totalRows: 0,
        totalPages: 0
      },
    }
  },
  methods: {

    onUploadHTCert(file) {
      let isFormValid = true
      let payload = new FormData()
      if(this.$helper.isEmpty(file)){
        isFormValid = false
        return
      }
      if(file.size > this.$uploadLimit){
        this.$helper.toastError(this, "Mohon upload dokumen dengan size lebih rendah dari 1 MB")
        isFormValid = false
      }
      // submit form data if every field is valid
      if(isFormValid){
        let postUrl = '/aphtPayment/uploadHTCertificate'
        let fileNameSplit = file.name.split(".")
        let fileExt = fileNameSplit[fileNameSplit.length-1]
        payload.append("collateralAphtId", this.$route.params.collateralId)
        payload.append("file", file)
        payload.append("extension", fileExt)
        // only send axios request if role is valid
        if(this.$helper.isRole(this.$availRoles['Cabang'])){
          this.formData.uploadHTCertificate.isValid = null
          this.formData.uploadHTCertificate.isSubmitting = true
          this.$axios.post(postUrl, payload).then(response => {
            if(response.status == 200){
              this.formData.uploadHTCertificate.feedback = file.name
              this.formData.uploadHTCertificate.isValid = true
              this.$helper.toastSuccess(this, "Upload Sertifikat HT Berhasil!")
            }
            else{
              this.$helper.toastError(this, "Upload Sertifikat HT Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
            }
          })
          .catch(error => {
            if(!this.$helper.isEmpty(error.response)){
              this.$helper.toastError(this, "Upload Sertifikat HT Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
            }
            else{
              this.$helper.toastError(this, "Upload Sertifikat HT Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
            }
          })
          .finally(() => {
            this.formData.uploadHTCertificate.value = null
            this.formData.uploadHTCertificate.isSubmitting = false
          })
        }
        else{
          this.formData.uploadHTCertificate.value = null
          this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
        }
      }
    },
    onUploadCoverNote(file) {
      let isFormValid = true
      let payload = new FormData()
      if(this.$helper.isEmpty(file)){
        isFormValid = false
        return
      }
      if(file.size > this.$uploadLimit){
        this.$helper.toastError(this, "Mohon upload dokumen dengan size lebih rendah dari 1 MB")
        isFormValid = false
      }
      // submit form data if every field is valid
      if(isFormValid){
        let postUrl = '/aphtPayment/uploadCovernote'
        let fileNameSplit = file.name.split(".")
        let fileExt = fileNameSplit[fileNameSplit.length-1]
        payload.append("collateralAphtId", this.$route.params.collateralId)
        payload.append("file", file)
        payload.append("extension", fileExt)
        // only send axios request if role is valid
        if(this.$helper.isRole(this.$availRoles['Cabang'])){
          this.formData.uploadCoverNote.isValid = null
          this.formData.uploadCoverNote.isSubmitting = true
          this.$axios.post(postUrl, payload).then(response => {
            if(response.status == 200){
              // console.log(response)
              this.formData.uploadCoverNote.feedback = file.name
              this.formData.uploadCoverNote.isValid = true
              this.$helper.toastSuccess(this, "Upload Cover Note Berhasil!")
            }
            else{
              this.$helper.toastError(this, "Upload Cover Note Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
            }
          })
          .catch(error => {
            if(!this.$helper.isEmpty(error.response)){
              this.$helper.toastError(this, "Upload Cover Note Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
            }
            else{
              this.$helper.toastError(this, "Upload Cover Note Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
            }
          })
          .finally(() => {
            this.formData.uploadCoverNote.value = null
            this.formData.uploadCoverNote.isSubmitting = false
          })
        }
        else{
          this.formData.uploadCoverNote.value = null
          this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
        }
      }
    },

    createInvoice(event) {
      event.preventDefault()

      let isFormValid = true
      let obj = {}

      // Validate formData values
      for(const [key, data] of Object.entries(this.formData)){
        // check file upload
        if(key == "uploadHTCertificate" || key == "uploadCoverNote"){
          if(data.isRequired && !data.isValid){
            data.isValid = false
            isFormValid = false
          }
        }
        // check Vendor ID field
        else if(key == "vendorId"){
          if(data.isValid){
            obj[data.payloadKey] = data.value
          }
          else if(data.isRequired){
            data.feedback = "Please check Vendor ID validity."
            data.isValid = false
            isFormValid = false
          }
          else{
            data.isValid = null
          }
        }
        // check vendor data fields
        else if (key == "vendorName" || key == "vendorBank" || key == "vendorBankAccount" || key == "vendorAccountName" || key == "vendorStatus" || key == "vendorAddress" || key == "vendorCity"){
          if(!this.$helper.isEmpty(data.value)){
            data.isValid = null
            obj[data.payloadKey] = data.value
          }
          else if(data.isRequired){
            data.isValid = null
            obj[data.payloadKey] = ""
          }
          else{
            data.isValid = null
          }
        }
        // check remaining input fields
        else if (key == "notaryFee" || key == "notes" || key == "certificateNo" || key == "certificateDate"){
          if(!this.$helper.isEmpty(data.value)){
            data.isValid = null
            obj[data.payloadKey] = data.value
          }
          else if(data.isRequired){
            data.isValid = false
            isFormValid = false
          }
          else{
            data.isValid = null
          }
        }
      }

      if (isFormValid) {
        let postUrl = '/aphtPayment/addMemo'
        this.isSubmitting = true

        obj.collateralAphtId = this.$route.params.collateralId
        obj.pokokPembiayaan = this.formData.contractDetail.pokokPembiayaanRaw

        // only send axios request if role is valid
        if(this.$helper.isRole(this.$availRoles['Cabang'])){
          this.$axios.post(postUrl, obj).then(response => {
            if(response.data.status){
              this.$helper.toastSuccess(this.$root, "Create Invoice Berhasil! " + (response.data.reason ? response.data.reason : ""))
              this.$router.push({ name: 'Invoice APHT Memo List', params: { collateralId: this.$route.params.collateralId } })
            }
          })
          .catch(error => {
            if(!this.$helper.isEmpty(error.response)){
              this.$helper.toastError(this, "Create Invoice Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
            }
            else{
              this.$helper.toastError(this, "Create Invoice Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
            }
          })
          .finally(() => {
            this.isSubmitting = false
          })
        }
        else{
          this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
        }
      }
    },
    
    // validate vendor ID button functionality
    validateVendorId() {
      let postUrl = '/mou/checkVendorId'
      let payload = new FormData()
      payload.append("vendorId", this.formData.vendorId.value)
      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['Cabang'])){
        this.formData.vendorId.isChecking = true
        this.$axios.post(postUrl, payload).then(response => {
          if(response.status == 200){
            this.formData.vendorId.isValid = true
            this.formData.vendorName.value = response.data.data.namaVendor
            this.formData.vendorBank.value = response.data.data.bank
            this.formData.vendorBankAccount.value = response.data.data.noRek
            this.formData.vendorAccountName.value = response.data.data.namaRek
            this.formData.vendorStatus.value = response.data.data.statusRek
            this.formData.vendorAddress.value = response.data.data.alamat
            this.formData.vendorCity.value = response.data.data.kota
          }
          else{
            this.formData.vendorId.feedback = "Vendor ID tidak valid! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : "Unknown Error")
            this.formData.vendorId.isValid = false
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.formData.vendorId.feedback = "Vendor ID tidak valid! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found")
          }
          else{
            this.formData.vendorId.feedback = "Vendor ID tidak valid! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error")
          }
          this.formData.vendorId.isValid = false
        })
        .finally(() => {
          this.formData.vendorId.isChecking = false
        })
      }
      else {
        this.formData.vendorId.feedback = "Access Denied!"
        this.formData.vendorId.isValid = false
      }
    },
    // clear vendor inputs on vendor ID change
    clearFormVendor() {
      this.formData.vendorId.isValid = null
      this.formData.vendorName.value = ''
      this.formData.vendorBank.value = ''
      this.formData.vendorBankAccount.value = ''
      this.formData.vendorAccountName.value = ''
      this.formData.vendorStatus.value = ''
    },

    getDetail(collateralId){
      this.isLoading = true
      let getUrl = "/aphtPayment/getCollateralDetailToCreateMemo"
      let params = {}
      params['collateralAphtId'] = collateralId
      this.$axios.get(getUrl, {params: params}).then(response => {
        if(response.status == 200){
          this.formData.contractDetail.applNo = this.$helper.showData(response.data.data.applNo, "string")
          this.formData.contractDetail.nomorSertifikatTanah = this.$helper.showData(response.data.data.nomorSertifikatTanah, "string")
          this.formData.contractDetail.namaSertifikatTanah = this.$helper.showData(response.data.data.namaSertifikatTanah, "string")
          this.formData.contractDetail.statusHak = this.$helper.showData(response.data.data.statusHak, "string")
          this.formData.contractDetail.contractNo = this.$helper.showData(response.data.data.contractNo, "string")
          this.formData.contractDetail.nilaiPenjaminan = "Rp " + this.$helper.showData(response.data.data.nilaiPenjaminan, "number")
          this.formData.contractDetail.notaryFee = "Rp " + this.$helper.showData(response.data.data.notaryFee, "number")
          this.formData.contractDetail.nilaiAppraisal = "Rp " + this.$helper.showData(response.data.data.nilaiAppraisal, "number")
          this.formData.contractDetail.pokokPembiayaan = "Rp " + this.$helper.showData(response.data.data.pokokPembiayaan, "number")
          this.formData.contractDetail.pokokPembiayaanRaw = response.data.data.pokokPembiayaan
        }
        else{
          this.$helper.toastError(this, "Load Detail Memo Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
        }
      })
      .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Load Detail Memo Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
          }
          else{
            this.$helper.toastError(this, "Load Detail Memo Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
      })
      .finally(() => {
        this.isLoading = false
      })
    },
  },
  computed: {

  },
  mounted() {
    this.getDetail(this.$route.params.collateralId)
  },
  created(){
  }
}
</script>

<style>

</style>
